import { createAction } from '@reduxjs/toolkit';
import EcomEngineAPI from 'api/ecom_engine_api';
import { trackError } from 'utils/helpers';

const fetchDocumentsStarted = createAction('booking/fetchDocumentsStarted');
const fetchDocumentsSucceeded = createAction('booking/fetchDocumentsSucceeded');
const fetchDocumentsFailed = createAction('booking/fetchDocumentsFailed');
const setDocuments = createAction('resources/setDocuments');

const fetchDocuments = (bookingId) => (dispatch) => {
  dispatch(fetchDocumentsStarted());

  return EcomEngineAPI.booking
    .documents(bookingId)
    .then((json) => {
      dispatch(fetchDocumentsSucceeded());
      dispatch(setDocuments(json));
    })
    .catch((error) => {
      trackError(error);
      dispatch(fetchDocumentsFailed(error.message));
    });
};

const generateDocumentsStarted = createAction(
  'booking/generateDocumentsStarted'
);
const generateDocumentsSucceeded = createAction(
  'booking/generateDocumentsSucceeded'
);
const generateDocumentsFailed = createAction('booking/generateDocumentsFailed');

const generateDocuments = (bookingId) => (dispatch) => {
  dispatch(generateDocumentsStarted());

  return EcomEngineAPI.booking
    .generateDocuments(bookingId)
    .then((json) => {
      dispatch(generateDocumentsSucceeded());
      dispatch(setDocuments(json));
    })
    .catch((error) => {
      trackError(error);
      dispatch(generateDocumentsFailed(error.message));
    });
};

export {
  fetchDocumentsStarted,
  fetchDocumentsSucceeded,
  fetchDocumentsFailed,
  fetchDocuments,
  generateDocumentsStarted,
  generateDocumentsSucceeded,
  generateDocumentsFailed,
  generateDocuments,
  setDocuments,
};
